// extracted by mini-css-extract-plugin
export default {"flex":"TagMasterTable_flex__afeRT","btn":"TagMasterTable_btn__KX-0K","btn1":"TagMasterTable_btn1__Shxs2","main":"TagMasterTable_main__QD0Ne","center":"TagMasterTable_center__rv6UT"};